import React from "react";
import icon from "../assets/icon-upload.png"; // Ajusta esta ruta al lugar donde guardaste tu logo

// En Uploader.js
const Uploader = ({ inputProps }) => {
  return (
    <div className="upload-container">
      <div className="upload-box" onClick={() => document.getElementById('uploaderInput').click()}>
        <div className="upload-area">
          {/* Asegúrate de tener un icono de carga disponible en tu proyecto */}
          <img src={icon}  alt="Upload icon" />
          <p>Arrastra o sube tus archivos. <span className="browse">Aquí</span></p>
          <p className="supports">Formato permitido: .pdf</p>
          {/* El input ahora está oculto pero sigue siendo funcional */}
          <input {...inputProps()} id="uploaderInput" style={{ display: 'none' }} />
        </div>
      </div>
    </div>
  );
};

export default Uploader;
